import { render, staticRenderFns } from "./ControlsPage.vue?vue&type=template&id=7c2575b0&"
import script from "./ControlsPage.vue?vue&type=script&lang=js&"
export * from "./ControlsPage.vue?vue&type=script&lang=js&"
import style0 from "./ControlsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports